import HTTP from "@/_helpers/http";
import { TESTINGACCOUNTS__API } from "@/_helpers/urls";
import { TESTINGACCOUNTS__MUTATIONS } from "../mutation-types";
import { TESTINGACCOUNTS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  accounts: [],
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [TESTINGACCOUNTS__MUTATIONS.TESTINGACCOUNTS](state, data) {
    state.accounts = data?.data?.accounts;
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [TESTINGACCOUNTS__ACTIONS.TESTINGACCOUNTS]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${TESTINGACCOUNTS__API.TESTINGACCOUNTS}${queryParams ? `?${queryParams}` : ''}`
      );
      commit(TESTINGACCOUNTS__MUTATIONS.TESTINGACCOUNTS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [TESTINGACCOUNTS__ACTIONS.CREATETESTINGACCOUNT]({ dispatch }, parameter) {
    try {
      const url = `${TESTINGACCOUNTS__API.CREATETESTINGACCOUNT}`;
      const response = await HTTP().post(url, { trading_account_no: parameter.trading_account_no, comment: parameter.comment });
      if (response.status === 200) {
        toast.success("Test Account Added Successfully");
      }
      await dispatch(TESTINGACCOUNTS__ACTIONS.TESTINGACCOUNTS);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
